// extracted by mini-css-extract-plugin
export default {"mainContainer":"RegionSettingsComponent_mainContainer__Oms26","regionList":"RegionSettingsComponent_regionList__KGkpi","regionItem":"RegionSettingsComponent_regionItem__Pl6KJ"};